// @ts-nocheck
import type { FC } from "react";
import { useRef } from "react";

import * as _ from "lodash";
import styled from "styled-components";

import { Box } from "@similarweb/ui-components";

import { chosenSites } from "app/common/services/chosenSites";
import { WeShare } from "app/components/weshare/weshare";
import { WidgetLoader } from "app/components/widget-loader/WidgetLoader";
import { WidgetTitle } from "app/components/widget-title/WidgetTitle";
import { i18nFilter } from "app/filters/i18nFilter";
import { TitleContainer } from "app/pages/website-analysis/social-overview/social-total-visits/StyledComponents";
import { availableDataTypes } from "app/pages/website-analysis/traffic-sources/display-ads/common/DisplayAdsTypes";
import { PieChart } from "app/pages/website-analysis/traffic-sources/display-ads/common/PieChart";
import DurationService from "app/services/DurationService";
import utils from "app/Shared/utils";
import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";

declare const similarweb: { utils: { formatKeyValue: any; formatTopList: any } };
const StyledBox = styled(Box)`
    width: 100%;
    height: 325px;
    display: flex;
    flex-direction: column;
`;

export const SocialOverviewSourcesDistribution: FC<{
    data: Array<{ Count: number; DisplayUrl: string; Name: string; Value: number }>;
    loading?: boolean;
    error?: boolean;
    duration: string;
    webSource: string;
}> = ({ data, loading, error, duration, webSource }) => {
    const i18n = i18nFilter();
    const title = i18n(`social.source.distribution.title`);
    const tooltip = i18n("social.source.distribution.title.tooltip", { param: "social" });
    const chartRef = useRef<HTMLDivElement>(null);
    const mainDomain = chosenSites.getPrimarySite().name;
    const processedData = utils.formatKeyValue(
        _.map(utils.formatTopList(data, 6), function (item) {
            if (item.Name && item.Name.toLowerCase() !== "other" && item.Name.toLowerCase() !== "others") {
                item.Id = item.Name;
            } else {
                item.Name = "Others";
            }
            return item;
        }),
    );
    const tooltipHeaders = [
        i18n("analysis.source.ad.websites.table.columns.category.title"),
        i18n("wa.ao.graph.trafficshare"),
    ];
    const pieChartConfig = {
        chartType: availableDataTypes[1],
        tooltipHeaders,
        tooltipContainerWidth: 280,
        isEmptyStateSmall: true,
    };
    const pieChartData = processedData.map(([name, value]) => ({
        name: name,
        y: value,
        percent: value,
    }));
    const durationObject = DurationService.getDurationData(duration);
    const getDateRange = (durationObject) => [durationObject.raw.from, durationObject.raw.to];
    const [fromDate, toDate] = getDateRange(durationObject);
    const subTitleFilters = [
        {
            filter: "date",
            value: {
                from: fromDate.valueOf(),
                to: toDate.valueOf(),
                useRangeDisplay: fromDate.format("YYYY-MM") !== toDate.format("YYYY-MM"),
            },
        },
        {
            filter: "webSource",
            value: webSource,
        },
    ];
    const showError = error || data?.length === 0;
    return (
        <StyledBox ref={chartRef}>
            <TitleContainer>
                <WidgetTitle
                    title={title}
                    tooltip={tooltip}
                    filters={subTitleFilters}
                />
                <WeShare
                    chartRef={chartRef.current}
                    title={`${mainDomain} ${title}`}
                    description={`${mainDomain} ${title}`}
                    redirectUrl={`https://www.similarweb.com/website/${mainDomain}/#social`}
                />
            </TitleContainer>
            {loading ? (
                <WidgetLoader />
            ) : showError ? (
                <NoDataLandscape
                    title="global.nodata.notavilable"
                    subtitle={null}
                />
            ) : (
                <PieChart
                    pieChartData={pieChartData}
                    pieChartConfig={pieChartConfig}
                />
            )}
        </StyledBox>
    );
};
